<template>
  <picture>
    <source
      v-for="(source, sourceIdx) of getSourceList"
      :key="sourceIdx"
      :srcset="source.srcset"
      :media="source.media"
      :type="source.type"
    />
    <img
      :class="imgClass"
      :src="getMainSource"
      :title="title"
      :alt="alt"
      :height="height"
      :width="width"
      :loading="loading"
    />
  </picture>
</template>

<script>
import { first, last, template, size, values, trimStart, trimEnd, get } from 'lodash-es'

export default {
  name: 'AdvHtmlPicture',
  props: {
    imgClass: {
      type: String,
      default: ''
    },
    width: {
      type: Number,
      default: null
    },
    height: {
      type: Number,
      default: null
    },
    alt: {
      type: String,
      default: ''
    },
    loading: {
      type: String,
      default: 'lazy'
    },
    srcsetProfile: {
      type: String,
      required: false,
      default: null
    },
    srcsetImage: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: false,
      default: ''
    }
  },
  computed: {
    getSourceList () {
      if (!this.areSrcSetsEnabled) {
        return []
      }
      const sourceList = []
      const formats = this.getSelectedProfile.formats
      const variants = this.getSelectedProfile.variants
      for (const format of Object.values(formats)) {
        const formatMimeType = this.getConfigImageFormatMimeTable[format]
        for (const variant of variants) {
          sourceList.push({
            media: variant.media,
            srcset: this.applyResizerForKeyAndFormat(variant.resize_key, format),
            type: formatMimeType
          })
        }
      }
      return sourceList
    },
    getMainSource () {
      if (size(this.getSourceList) <= 0) {
        return window.advAppData.url.assets + this.getSelectedImage
      }
      return last(this.getSourceList).srcset
    },
    areSrcSetsEnabled () {
      return false !== this.getConfig
    },
    getConfig () {
      return get(this.$store.getters.config, 'srcSets', false)
    },
    getConfigTemplate () {
      return template(this.getConfig.template)
    },
    getConfigProfiles () {
      return this.getConfig.profiles
    },
    getConfigImageFormatMimeTable () {
      return this.getConfig.imageFormatMimeTable
    },
    getSelectedProfile () {
      if (null === this.srcsetProfile) {
        return first(values(this.getConfigProfiles))
      }
      return this.getConfigProfiles[this.srcsetProfile]
    },
    getSelectedImage () {
      let src = this.srcsetImage
      src = trimStart(src, ' /\t')
      src = trimEnd(src, ' \t')
      return src
    }
  },
  methods: {
    applyResizerForKeyAndFormat (key, format) {
      format = this.resolveAutoImageFormat(format)
      return window.advAppData.url.assets + this.getConfigTemplate({ src: this.getSelectedImage, key, format })
    },
    resolveAutoImageFormat (format) {
      if ('auto' !== format) {
        return format
      }
      return this.getConfig.resolvedAutoFormat || format
    }
  }
}
</script>
